import { TextField } from '@mui/material';

import { mergeSx, mergeSxWithOutlinedBorder } from '../../utils/general';
import { FORTA_BLACK } from '../../../../utils/colors';

import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import type { FAutocompleteDefaultTextFieldProps } from '../types';

export function renderDefaultAutocompleteInput(
  params: AutocompleteRenderInputParams,
  textFieldProps: FAutocompleteDefaultTextFieldProps,
) {
  const {
    label,
    helperText,
    error,
    required,
    disabled,
    fullWidth,
    placeholder,
    InputLabelProps,
    variant,
    size,
    sx,
    hideLabelRequiredAsterisk,
    inputAutoComplete,
    inputAriaLabel,
  } = textFieldProps;

  return (
    <TextField
      {...params}
      label={label}
      helperText={helperText}
      error={error}
      required={required}
      disabled={disabled}
      fullWidth={fullWidth}
      placeholder={placeholder}
      variant={variant ?? 'outlined'}
      size={size}
      inputProps={{
        ...params.inputProps,
        autoComplete: inputAutoComplete ?? params.inputProps.autoComplete,
        'aria-label': inputAriaLabel ?? params.inputProps['aria-label'],
      }}
      InputLabelProps={{
        ...params.InputLabelProps,
        ...InputLabelProps,
        required: hideLabelRequiredAsterisk ? false : undefined,
        shrink: true,
        sx: mergeSx({ color: FORTA_BLACK }, InputLabelProps?.sx),
      }}
      sx={mergeSxWithOutlinedBorder(sx)}
    />
  );
}
